/**
 * Convert a string to snake_case
 * @param text - The text to convert
 * @returns The snake_case version of the text
 */
export const toSnakeCase = (text: string | undefined): string => {
    if (!text) return ''

    return text
        .replace(/\s+/g, '_') // Replace spaces with underscores
        .replace(/^_/, '') // Remove leading underscore
        .toLowerCase()
        .replace(/__+/g, '_') // Replace multiple underscores with single underscore
}

/**
 * Convert a string to URL-friendly slug
 * @param text - The text to convert
 * @returns The URL-friendly slug version of the text
 */
export const toSlug = (text: string | undefined): string => {
    if (!text) return ''

    const umlautMap: Record<string, string> = { ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' };

    return text
        .toLowerCase()
        .replace(/[äöüß]|[^a-z0-9]+/g, (match) => umlautMap[match] || '-')
        .replace(/^-+|-+$/g, '')
        .substring(0, 100)
}





